import { Router } from '@angular/router';
import { AppRoutesDefinitions } from '@app/app.routes';

const PUBLIC_ROUTE_PREFIXES = [
  `/${AppRoutesDefinitions.PUBLIC}`,
  `/${AppRoutesDefinitions.AUTH_LINK}`,
];

export const isPublicRouteUrl = (url: string | null | undefined): boolean => {
  const path = (url ?? '').split(/[?#]/)[0];

  return PUBLIC_ROUTE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
};

export const isOnPublicRoute = (router: Router): boolean =>
  isPublicRouteUrl(
    router.getCurrentNavigation()?.finalUrl?.toString() ?? router.url,
  );
